import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";
import { api } from "../../lib/api";
import { DemoModeToggle } from "./AdminOps";
import { OperatorConfig, Readiness } from "./TopupOperatorConfig";
import { TopupOrders } from "./TopupOrders";

export function AdminTopups() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/topup-config").then(({ data: d }) => setData(d));
  useEffect(() => { load(); }, []);
  const update = (op) => (saved, readiness) => setData((d) => ({ ...d, [op]: { config: saved?.config || d[op].config, readiness: saved?.readiness || readiness } }));
  return (
    <div className="flex flex-col gap-4" data-testid="admin-topups">
      <DemoModeToggle onChange={load} />
      {data && <Tabs defaultValue="cst">
        <TabsList><TabsTrigger value="cst" data-testid="topup-tab-cst">CST</TabsTrigger><TabsTrigger value="unitel" data-testid="topup-tab-unitel">Unitel</TabsTrigger></TabsList>
        {["cst", "unitel"].map((op) => (
          <TabsContent key={op} value={op} className="flex flex-col gap-4">
            <Readiness r={data[op].readiness} op={op} onChange={update(op)} />
            <OperatorConfig op={op} initial={data[op].config} onSaved={update(op)} />
          </TabsContent>
        ))}
      </Tabs>}
      <TopupOrders />
    </div>
  );
}
